export default "__VITE_ASSET__BvI7mEke__"